<template>
  <div>
    <v-navigation-drawer app v-model="drawerData" @input="updateDrawer" color="#313a46">
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="white--text" >RPA - Painel Administrativo</v-list-item-title>
            <!-- Melhora isso por favor -->
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider></v-divider>
      <v-list nav dense >
        <v-list-item-group>
          <div v-for="(item, x) in itemsMenu" :key="x">
            <v-list
              v-if="!item.hasOwnProperty('children')"
              v-can:permission="item.permission"
            >
              <router-link :to="item.route">
                <v-list-item>
                  <v-list-item-icon>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </router-link>
            </v-list>
            <MenuLevel v-else :item="item" v-can:permission="item.permission" />
          </div>

          <v-list>
            <v-list-item @click="$keycloak.logout()">
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Sair</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import MenuLevel from "./MenuLevel.vue";
export default {
  components: {
    MenuLevel,
  },
  props: {
    drawer: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    drawerData: true,
    group: null,
    itemsMenu: [
      {
        icon: "mdi-view-dashboard",
        text: "Início",
        route: "/",
        // role: ["admin"],
      },
      {
        icon: "mdi-hammer-screwdriver",
        text: "Serviços",
        route: "/servicosPrestados",
        permission: "servico-prestado#list-all",
        // role: ["contabilidade", "concessionaria"],
      },
      {
        icon: "mdi-text-box-search",
        text: "Layouts",
        route: "/layout-xml",
        // role: ["admin"],
        permission: ["layout-nota#list-all"],
        children: [
          {
            permission: "layout-nota#list-all",
            icon: "mdi-xml",
            text: "XML",
            route: "/layout-xml",
            // role: ["admin"],
          },
        ],
      },
      {
        icon: "mdi mdi-application-cog-outline",
        text: "Grupo 4 (O.S.)",
        route: "",
        permission: [
          "bloqueio-prefeitura#list-all",
          "bloqueio-entrada-nf#list-all",
          "empresa-filial#list-all",
        ],

        children: [
          {
            icon: "mdi mdi-playlist-remove",
            text: "Código de Serviço",
            route: "/codigoServicoG4",
            permission: "bloqueio-prefeitura#list-all",
          },
        ],
      },
      {
        icon: "mdi-file-document-multiple",
        text: "Operação 52",
        route: "",
        // role: ["contabilidade", "concessionaria"],
        permission: ["nfe-ncm-contabilizar#list-all", "centro-custo#list-all"],
        children: [
          {
            icon: "mdi-abacus",
            text: "Contabilizar NCM",
            route: "/contabilizar",
            permission: "nfe-ncm-contabilizar#list-all",
            // role: ["contabilidade", "concessionaria"],
          },
          {
            icon: "mdi-link",
            text: "Empresas Centro de Custo",
            route: "/empresas",
            // role: ["contabilidade"],
            permission: "centro-custo#list-all",
          },
        ],
      },
      {
        icon: "mdi-block-helper",
        text: "Bloqueios",
        route: "",
        permission: [
          "bloqueio-prefeitura#list-all",
          "bloqueio-entrada-nf#list-all",
          "empresa-filial#list-all",
        ],

        children: [
          {
            icon: "mdi-office-building-remove",
            text: "Bloqueio de Prefeituras",
            route: "/bloqueioPrefeituras",
            permission: "bloqueio-prefeitura#list-all",
            // role: ["auditoria"],
          },
          {
            icon: "mdi-file-cancel",
            text: "Bloqueio de Notas",
            route: "/bloqueioEntradaNf",
            permission: "bloqueio-entrada-nf#list-all",
            // role: ["bloqueio-de-notas-NBS"],
          },
          {
            icon: "mdi-cog",
            text: "Bloqueio de Peças",
            route: "/bloqueioPecas",
            permission: "empresa-filial#list-all",
            // role: ["auditoria"],
          },
        ],
      },
      {
        icon: "mdi-sale",
        text: "Descontos",
        route: "/descontos",
        permission: "limpa-desconto-pecas#list-all",
        // role: ["pecas"],
      },
      {
        icon: "mdi-cash",
        text: "Despesa CNPJ",
        route: "/despesa",
        permission: "cnpj-despesa#list-all",
        // role: ["multimarcas"],
      },
      {
        icon: "mdi-email-multiple",
        text: "Grupos de E-mail",
        route: "/gruposEmail",
        permission: "email-grupo#list-all",
        // role: ["admin"],
      },
      {
        icon: "mdi-lock",
        text: "Portais e logins",
        route: "/portais",
        permission: "portal-acesso#list-all",
        // role: ["comercial"],
      },
      {
        icon: "mdi-home-city",
        text: "Unidades Consumidoras",
        route: "/unidades-consumidoras",
        permission: "portal-acesso#list-all",
      },
      {
        icon: "mdi-message-alert",
        text: "Mensagens LUA",
        route: "/mensagens-lua",
        permission: "channels-slack#list-all",
      }
    ],
  }),
  methods: {
    updateDrawer(value) {
      this.drawerData = value;
      this.$emit("setDrawerResponsiveness", value);
    },
  },

  watch: {
    group() {
      this.drawer = false;
    },
    drawer(value) {
      this.drawerData = value;
    },
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}

.v-list-item, .v-list-item--link {
  color: rgba(255, 255, 255, 0.5) !important;
}

.theme--light.v-icon {
  color: rgba(255, 255, 255, 0.5) !important;
}

.v-list-item--active {
  color: #fff !important;
}

.v-list-item--active >>> .theme--light.v-icon  {
  color: #fff !important;
}

.v-application a {
  color: #fff !important;
}
</style>
